import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';
import {
    TransferRequestBulkUploadDto,
    TransferRequestBulkJobDto
} from '../model/dto/TransferRequestBulkDto';

/**
 * Feature 46570 - Facade de la carga masiva de traspasos (nueva lógica paralela).
 * Apunta a los endpoints de TransferRequestBulkController en el BackOffice.
 */
@Injectable()
export class TransferRequestBulkFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    /** Sube el layout estructurado; el backend responde 202 con el OperationGuid. */
    UploadBulk(request: TransferRequestBulkUploadDto): Observable<RequestResponse<string>> {
        return this._httpClient.post<RequestResponse<string>>(
            this._urlBase + 'api/TransferRequestBulk/Upload', request);
    }

    /** Lista jobs; el backend resuelve el alcance (propios o todos segun permiso). */
    GetJobs(userEmail?: string, organization?: string): Observable<RequestResponse<TransferRequestBulkJobDto[]>> {
        let url = this._urlBase + 'api/TransferRequestBulk/Jobs';
        const params: string[] = [];
        if (userEmail) { params.push('userEmail=' + encodeURIComponent(userEmail)); }
        if (organization) { params.push('organization=' + encodeURIComponent(organization)); }
        if (params.length > 0) { url += '?' + params.join('&'); }
        return this._httpClient.get<RequestResponse<TransferRequestBulkJobDto[]>>(url);
    }

    /**
     * Descarga el Excel (.xlsx) de no procesados generado por el servidor (ClosedXML, con los
     * códigos como texto para no truncar). Se pide como Blob vía HttpClient para que pase por el
     * interceptor (lleva el token de sesión); el navegador NO arma el archivo. language: 0 = es, 1 = en.
     */
    DownloadNotProcessed(operationGuid: string, language: number): Observable<Blob> {
        const url = this._urlBase + 'api/TransferRequestBulk/NotProcessed/Download'
            + '?operationGuid=' + encodeURIComponent(operationGuid)
            + '&language=' + language;
        return this._httpClient.get(url, { responseType: 'blob' });
    }
}
